function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import ReadingFlagIcon from 'components/ReadingFlagIcon';
import App from 'modules/App';
import { formatDate } from 'helpers/datetime';
import intlShape from 'shapes/intlShape';
import { standardsSelector } from 'modules/PatientResults/selectors';
import messages from '../../../messages';
import styles from './Header.pcss';
var _React_Component;
class Header extends (_React_Component = React.Component) {
    render() {
        const { accountPatientProfile, phiSet, conversion, intl: { formatMessage }, glucoseLevelTargets } = this.props;
        const { glucoseReport, labels } = messages;
        const { startDate, endDate } = this.props.reportsDates;
        if (!accountPatientProfile || !phiSet) return null;
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.header,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles['header__left-col'],
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                className: styles.header__title,
                                children: `${accountPatientProfile.firstName} ${accountPatientProfile.lastName}`
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("strong", {
                                        children: `${formatMessage(glucoseReport.diabetesType)}: `
                                    }),
                                    App.messages.diabetesTypes[phiSet.diabetesType] ? /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.diabetesTypes[phiSet.diabetesType])) : '-'
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("strong", {
                                        children: `${formatMessage(glucoseReport.treatmentType)}: `
                                    }),
                                    App.messages.treatmentTypes[phiSet.treatmentType] ? /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.treatmentTypes[phiSet.treatmentType])) : '-'
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                children: [
                                    /*#__PURE__*/ _jsx("strong", {
                                        children: `${formatMessage(glucoseReport.dateOfBirth)}: `
                                    }),
                                    accountPatientProfile.dateOfBirth ? formatDate(accountPatientProfile.dateOfBirth) : '-'
                                ]
                            }),
                            accountPatientProfile.phone && /*#__PURE__*/ _jsxs("p", {
                                children: [
                                    /*#__PURE__*/ _jsx("strong", {
                                        children: `${formatMessage(labels.phone)}: `
                                    }),
                                    " ",
                                    accountPatientProfile.phone
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                children: [
                                    /*#__PURE__*/ _jsx("strong", {
                                        children: "Email:"
                                    }),
                                    " ",
                                    accountPatientProfile.email
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles['header__center-col'],
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: styles.header__title,
                            children: [
                                /*#__PURE__*/ _jsx("h1", {
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.headers.gestationalReportTitle))
                                }),
                                /*#__PURE__*/ _jsxs("h3", {
                                    className: styles.header__daterange,
                                    children: [
                                        formatDate(startDate),
                                        " - ",
                                        formatDate(endDate)
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles['header__right-col'],
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: styles.header__title,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.labels.legend))
                            }),
                            /*#__PURE__*/ _jsxs("table", {
                                className: styles['header__right-col-row'],
                                children: [
                                    /*#__PURE__*/ _jsx("thead", {
                                        children: /*#__PURE__*/ _jsxs("tr", {
                                            children: [
                                                /*#__PURE__*/ _jsx("th", {}),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: `${formatMessage(glucoseReport.high)}: `
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: `${formatMessage(glucoseReport.low)}: `
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("tbody", {
                                        children: [
                                            /*#__PURE__*/ _jsxs("tr", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: /*#__PURE__*/ _jsxs("p", {
                                                            children: [
                                                                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.labels.preMeal)),
                                                                ":",
                                                                /*#__PURE__*/ _jsx(ReadingFlagIcon, {
                                                                    flag: "PreMeal",
                                                                    className: "btn__icon"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            className: styles.header__high,
                                                            children: `> ${this.screenValue(glucoseLevelTargets.preMeal.highThreshold)} ${conversion.unitSymbol}`
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            className: styles.header__low,
                                                            children: `< ${this.screenValue(glucoseLevelTargets.preMeal.lowThreshold)} ${conversion.unitSymbol}`
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("tr", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: /*#__PURE__*/ _jsxs("p", {
                                                            children: [
                                                                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.labels.postMeal)),
                                                                ":",
                                                                /*#__PURE__*/ _jsx(ReadingFlagIcon, {
                                                                    flag: "PostMeal",
                                                                    className: "btn__icon"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            className: styles.header__high,
                                                            children: `> ${this.screenValue(glucoseLevelTargets.postMeal.highThreshold)} ${conversion.unitSymbol}`
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            className: styles.header__low,
                                                            children: `< ${this.screenValue(glucoseLevelTargets.postMeal.lowThreshold)} ${conversion.unitSymbol}`
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("tr", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: /*#__PURE__*/ _jsxs("p", {
                                                            children: [
                                                                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.flags.Fasting)),
                                                                ":",
                                                                /*#__PURE__*/ _jsx(ReadingFlagIcon, {
                                                                    flag: "Fasting",
                                                                    className: "btn__icon"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            className: styles.header__high,
                                                            children: `> ${this.screenValue(glucoseLevelTargets.preMeal.highThreshold)} ${conversion.unitSymbol}`
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            className: styles.header__low,
                                                            children: `< ${this.screenValue(glucoseLevelTargets.preMeal.lowThreshold)} ${conversion.unitSymbol}`
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "screenValue", (val)=>this.props.conversion.toDisplay(val));
    }
}
_define_property(Header, "propTypes", {
    // Implicit props
    intl: intlShape.isRequired,
    phiSet: PropTypes.object,
    accountPatientProfile: PropTypes.object,
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    conversion: PropTypes.object,
    reportsDates: PropTypes.object,
    glucoseLevelTargets: PropTypes.object
});
const mapStateToProps = (state)=>({
        glucoseLevelTargets: standardsSelector(state)
    });
const ConnectedHeader = connect(mapStateToProps)(Header);
export default withStyles(styles)(injectIntl(ConnectedHeader));
